import { createFileRoute, type SearchSchemaInput } from "@tanstack/react-router"
import { z } from "zod"

const demographicsSchema = z.object({
  facility: z.coerce.number().optional().catch(undefined),
})

export const Route = createFileRoute("/_app/reports/demographics/")({
  validateSearch: (search: SearchSchemaInput) => demographicsSchema.parse(search),
})
